import PageContent from "../components/PageContent";

const HomePage = () =>{
    return <PageContent title="Welcome !!">
        <p>Browser all our ammazing events</p>
        </PageContent>
};

export default HomePage;